import React, { useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import ReactGA from 'react-ga';
import { Form, Input, Button, Divider } from 'antd';

import FacebookLogin from '../../Login/facebook';
import { DownloadApp } from './Login-children';
import { showLoading, navModal, navModalMode } from '../../../Actions/Page';
import { showError } from '../../../Actions/Message';
import { fetchLogin, showLegalModal } from '../../../Actions/Authentication';
import { auth } from '../../../Service/Firebase';
import { GoogleAuthProvider, signInWithPopup, getAdditionalUserInfo } from 'firebase/auth';
import { fetch } from '../../../Utilitys/ApiRequest';

import { ReactComponent as EmailIcon } from '../../../assets/icons/email.svg';
import { ReactComponent as PasswordIcon } from '../../../assets/icons/password.svg';
import { ReactComponent as GoogleIcon } from '../../../assets/icons/google.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/icons/facebook.svg';
import { ReactComponent as ScanQrCodeIcon } from '../../../assets/icons/scanQrCode.svg';

import './index.scss';
//
ReactGA.pageview(window.location.pathname + window.location.search);

const Login = (props) => {
   const dispatch = useDispatch();

   const schema = Yup.object().shape({
      username: Yup.string()
         .test('email-or-phone', 'อีเมลหรือเบอร์โทรศัพท์ไม่ถูกต้อง', (value) => {
            if (!value) return false;

            // Check if it's a valid email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isEmail = emailRegex.test(value);

            // Check if it's a valid Thai phone number (0XXXXXXXXX)
            const phoneRegex = /^[0][0-9]{9}$/;
            const isPhone = phoneRegex.test(value);
            return isEmail || isPhone;
         })
         .required('กรุณากรอกอีเมลหรือเบอร์โทรศัพท์'),
      password: Yup.string()
         .test('password', 'รหัสผ่านไม่ถูกต้อง', (value) => {
            if (!value) return false;
            // Check if it's a valid password
            const passwordRegex = /^[0-9a-zA-Z!#@$%^&*()-_+=/\\'":;.`~]{6,}$/;
            return passwordRegex.test(value);
         })
         .required('กรุณากรอกรหัสผ่าน')
   });

   const formik = useFormik({
      initialValues: {
         username: '',
         password: ''
      },
      validationSchema: schema,
      onSubmit: (values) => {
         props.dispatch(
            fetchLogin(
               'email',
               {
                  userID: values.username,
                  userPassword: values.password
               },
               props.match.path
            )
         );
      }
   });

   // const handleLineLogin = () => {
   //    var channelid = '1586815286';
   //    var callbackurl = authenObj + '/login';
   //    var state = 'LineCallBack';
   //    var url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${channelid}&redirect_uri=${callbackurl}&scope=profile&state=${state}`;
   //    window.location.href = url;
   // };

   const handleLoginWithGoogle = () => {
      const provider = new GoogleAuthProvider();
      auth.languageCode = 'th';
      signInWithPopup(auth, provider)
         .then(async (result) => {
            const user = getAdditionalUserInfo(result).profile;
            let payload = {
               id: user.id,
               email: user.email,
               name: user.name,
               picture: user.picture,
               given_name: user.given_name,
               family_name: user.family_name
            };

            await handleIdentitiesExistUser(payload, 'gmail');
         })
         .catch((error) => {
            props.dispatch(showError({ message: `Gmail Login Error ${error.message}` }));
         });
   };

   const handleLoginWithFacebook = async (result, data) => {
      if (!result) {
         return;
      }

      await handleIdentitiesExistUser(data.user, 'facebook');
      props.dispatch(showLoading(false));
   };

   const handleIdentitiesExistUser = async (payload, providerType) => {
      try {
         const convertProviderType = providerType === 'gmail' ? 'google' : providerType;
         const response = await fetch(
            'get',
            `authorize/identities/exists?memberID=${payload.id}&providerType=${convertProviderType}`
         );

         const signInPayload = {
            visible: true,
            providerType: providerType,
            payload: payload
         };

         if (response.data && response.data.isNewMember) {
            props.dispatch(showLegalModal(signInPayload));
            props.dispatch(navModal(false));
         } else {
            props.dispatch(fetchLogin(providerType, payload, props.match.path));
         }
      } catch (error) {
         props.dispatch(showError(error));
      }
   };

   const handleLoginWithQrCode = () => {
      if (props.Page.screensize.width <= 900) {
         props.history.push('/login/qrcode');
      } else {
         props.toQrcode(true);
      }
   };

   const handleClickForgotPassword = () => {
      if (props.Page.screensize.width <= 900) {
         props.history.push('/renewpassword');
      } else {
         props.toForgetPassword(true);
      }
   };

   const handleClickRegister = () => {
      if (props.Page.screensize.width <= 900) {
         props.history.push('/register');
      } else {
         props.toRegister();
      }
   };

   useEffect(() => {
      dispatch(navModal(true));
      dispatch(navModalMode({ loginModal: 1, registerModal: 0, registerEmailModal: 0 }));
   }, [props.Authentication.userToken]);

   return (
      <div className='login-container'>
         <h1>เข้าสู่ระบบ</h1>
         <form className='form-container' onSubmit={formik.handleSubmit}>
            <div className='form-group'>
               <label htmlFor='username'>อีเมล หรือ เบอร์โทรศัพท์</label>
               <Input
                  type='text'
                  id='username'
                  name='username'
                  className={formik.touched.username && formik.errors.username ? 'error' : ''}
                  placeholder='กรอกอีเมล หรือ เบอร์โทรศัพท์'
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  prefix={<EmailIcon />}
               />
               {formik.touched.username && formik.errors.username && <p className='error'>{formik.errors.username}</p>}
            </div>
            <div className='form-group'>
               <label htmlFor='password'>รหัสผ่าน (*)</label>
               <Input.Password
                  type='password'
                  id='password'
                  name='password'
                  className={formik.touched.password && formik.errors.password ? 'error' : ''}
                  placeholder='กรอกรหัสผ่าน'
                  prefix={<PasswordIcon />}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
               />
               <div className='flex-container'>
                  <p className='error'>
                     {formik.touched.password && formik.errors.password ? formik.errors.password : ''}
                  </p>
                  <Link className='forgot-password-link' onClick={handleClickForgotPassword}>
                     ลืมรหัสผ่าน?
                  </Link>
               </div>
            </div>
            <Button htmlType='submit' loading={props.Authentication.loading} disabled={props.Authentication.loading}>
               {props.Authentication.loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
            </Button>
         </form>
         <Divider style={{ margin: '2rem 0' }}>หรือ</Divider>
         <div className='social-login-container'>
            <Button htmlType='button' onClick={handleLoginWithGoogle} size='large'>
               <GoogleIcon />
               Google
            </Button>
            <FacebookLogin onLogin={handleLoginWithFacebook}>
               <Button htmlType='button' size='large'>
                  <FacebookIcon />
                  Facebook
               </Button>
            </FacebookLogin>
            <Button htmlType='button' onClick={handleLoginWithQrCode} size='large'>
               <ScanQrCodeIcon />
               QR Code
            </Button>
         </div>
         <div className='register-account'>
            คุณยังไม่มีบัญชีใช่ไหม? <span onClick={handleClickRegister}>สมัครสมาชิก</span>
         </div>
         <DownloadApp />
      </div>
   );
};

const mapStateToProps = (state) => {
   return { Page: state.Page, Authentication: state.Authentication };
};

Login.propTypes = {
   form: PropTypes.object,
   dispatch: PropTypes.func,
   history: PropTypes.object,
   Authentication: PropTypes.object,
   location: PropTypes.object,
   isModal: PropTypes.bool
};
export default withRouter(connect(mapStateToProps)(Form.create({ name: 'normal_login' })(Login)));
